var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionAltitudeAscent16({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4h2.586L1.293 8.293l1.414 1.414L7 5.414V8h2V2H3v2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14V5h-1l-8 8v1h9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionAltitudeAscent16);
export default __webpack_public_path__ + "static/media/ic_action_altitude_ascent_16.ad1ecd311d563f73f5be37a34ee3140c.svg";
export { ForwardRef as ReactComponent };